import React, { useEffect, useMemo, useState } from "react";
import { Wrapper } from "../HOC";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from "react-router-dom";
import ContentDetails from "../components/ContentDetails";
import { useProperty } from "../context/PropertyContext";
import LoadingModal from "../components/Loader/LoadingModal";
import { closeModal, openModal } from "../redux/modal/modalRedux";
import { useDispatch } from "react-redux";

const Contents = () => {
  const { getrooms, rooms, properties, getcontents, contents, loading } = useProperty();
  const [propertyName, setPropertyName] = useState("");
  const [Index, setIndex] = useState(0);
  const [roomIndex, setRoomIndex] = useState(0);
  const dispatch = useDispatch();

  const handleInputChange = async (value, index) => {
    setRoomIndex(0);
    await getrooms(value);
    setIndex(index);
    setPropertyName(value);
  };
  const handleSelectRoom = async (value, index) => {
    await getcontents(propertyName, value);
    setRoomIndex(index);
  };

  const propertyList = useMemo(() => {
    return properties.map((property) => property.propertyName);
  }, [properties]);

  const roomList = useMemo(() => {
    return rooms.map((room) => room.room);
  }, [rooms]);

  useEffect(() => {
    if (propertyList.length > 0) {
      getrooms(propertyList[0]);
      setPropertyName(propertyList[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyList]);

  useEffect(() => {
    if (roomList.length > 0 && propertyName) {
      getcontents(propertyName, roomList[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomList, propertyName]);

  useEffect(() => {
    if (loading) {
      dispatch(openModal());
    } else {
      dispatch(closeModal());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <Wrapper>
      <LoadingModal />
      <div>
        <div className="flex items-center pb-3">
          <p className="text-2xl font-bold pr-10">Contents</p>
          <Link to="/contents/addcontent">
            <div className="flex items-center justify-center py-2 px-7 border-2 border-primary font-medium text-primary rounded-xl cursor-pointer hover:bg-primary hover:text-white">
              <AiOutlinePlus className="text-lg" />
              <p className="text-xs pl-3">ADD</p>
            </div>
          </Link>
        </div>
        <p className="font-semibold text-[15px]">Properties</p>
        <div className="flex items-center mb-5 mt-2 flex-wrap gap-4">
          {propertyList.map((property, index) => (
            <button
              key={index}
              onClick={() => handleInputChange(property, index)}
              className={`py-2 px-3 rounded-md ${index === Index ? "bg-primary text-white" : "text-black  border-2 text-opacity-50"} text-xs mr-2`}
            >
              {property}
            </button>
          ))}
        </div>{" "}
        <p className="font-semibold text-[15px]">Rooms</p>
        {roomList.length > 0 ? (
          <div className="flex items-center mb-5 mt-2 flex-wrap gap-4">
            {roomList.map((room, index) => (
              <button
                key={index}
                onClick={() => handleSelectRoom(room, index)}
                className={`py-2 px-3 rounded-md ${
                  index === roomIndex ? "border-primary text-primary" : "text-opacity-50 text-black"
                } border-2 text-xs mr-2`}
              >
                {room}
              </button>
            ))}
          </div>
        ) : (
          <p className="text-[14px] text-red-700 mb-6">No room found for this property</p>
        )}
        <div className="pb-5">
          <ContentDetails contents={contents} />
        </div>
      </div>
    </Wrapper>
  );
};

export default Contents;
